import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import EnableMusic from '../components/EnableMusic';
import VideoId from '../components/VideoId';
import Login from '../components/dashboard/Login';
import Auth from '../components/Auth';
import { FaSpinner } from 'react-icons/fa';
import logo2 from '../img/logo.png';
import axios from 'axios';
import translations from '../translations';
import NavBar from '../components/NavBar';

function Music() {
  const [login, setLogin] = useState(true);
  const [ownerEmail, setOwnerEmail] = useState('');
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  useEffect(() => {
    function musicStatus() { 
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
        .then(response => {
          const music_activation = response.data.music_activation;
          if(music_activation){
            setLoading(false);
          } else {
            setLoading(false);
          }
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }
    
    musicStatus();
  }, [id]);

  return (
    <div>
      <Helmet>
        <title>{t.backgroundMusic} | {process.env.REACT_APP_SITE_NAME}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {loading ? (
        <div className="fixed inset-0 flex flex-col items-center justify-center space-y-5">
          <FaSpinner className="text-4xl text-black animate-spin" />
          <img src={logo2} alt="Logo" className="h-12 mb-4" />
        </div>
      ):(
      <div>
        <Auth id={id} setLogin={setLogin} setOwnerEmail={setOwnerEmail} />
        {login ? 
          (
            <div>
              <>
                {/* <NavBar /> */}
                <NavBar />
                <div className="md:p-24 py-24 flex items-center justify-center">
                  <div className="bg-white px-8 py-12 rounded-md md:shadow-lg max-w-md w-full text-center">
                    <h1 className="text-2xl font-bold mb-4">{t.backgroundMusic}</h1>
                    <div className='space-y-4 mb-6'>
                      <p className="text-gray-700">
                        {t.copyPasteYoutubeLink}
                      </p>
                    </div>
                    <EnableMusic />
                    <VideoId />
                  </div>
                </div>
              </>
            </div>
          ) : ( 
            <div>
              <Login ownerEmail={ownerEmail} setLogin={setLogin} />
            </div>
          )
        }
      </div>)}
    </div>
  );
}

export default Music;
